import { compose } from "redux";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from 'withRouter'
import { Scrollbars } from 'react-custom-scrollbars';
import OutsideClickHandler from 'react-outside-click-handler';

import { DownCevron, UpCevron } from "images/common";
import classNames from "classnames";

class SelectItemCard extends Component {
  state = {
    showExpand: false,
    isOptionSelected: false
  }

  onEdit = () => {
    this.props.onExpand && this.props.onExpand(!this.state.showExpand)
    this.setState({ showExpand: !this.state.showExpand })
  }

  onSelect = (name, id) => {
    this.setState({ isOptionSelected: true, showExpand: !this.state.showExpand })
    const getSelectedItem = this.props.data && this.props.data.find(item => item.name === name)
    this.props.onSelectOption(name, id, getSelectedItem)
    this.props.onExpand && this.props.onExpand(!this.state.showExpand)
  }

  render() {
    const { showExpand } = this.state;
    const { onEdit, icon, disabled, wrapperClass, data = [], selectedOption, imageKey, keepSelected, selectedTitle, isLight, color, isLarge, disableSelected, autoHide = true } = this.props
    const selectedEx = data && data.find(item => item.name === selectedOption)
    const filteredData = () => {
      if (!keepSelected) {
        return data && data.filter(item => item.name !== selectedOption)
      }
      return data
    }

    return (
      <OutsideClickHandler
        onOutsideClick={() => this.setState({ showExpand: false })}
      >
        <div
          className={classNames('popup__flow-modules content-box create_card-box', {
            'cursor': onEdit,
            'disabled-content-box': disabled,
            'create_card-box--light': isLight,
            [wrapperClass]: wrapperClass,
            'create_card-box_isOpen': showExpand,
            'create_card-box_isOpen--light': isLight && showExpand,
          })}
        >
          <div className="">
            <div className="data-table__table">
              <div className="data-table__body">
                <div
                  className={classNames(
                    'create_card-option', {
                    'create_card-option-selected create_card-option-selected-item': !isLight,
                    'create_card-option_isOpen--light': isLight && showExpand,
                    'create_card-option_isOpen': showExpand,
                    [color]: color
                  })}
                  onClick={() => this.onEdit(this.state.showExpand)}
                >
                  <div className={classNames("create_card__icon", imageKey && 'create_card__icon--image')}>
                    <div className={`checkbox`}>
                      <div className={classNames("checkbox__image checkbox__image_lg checkbox__empty", imageKey && 'checkbox__image--image')}>
                        {imageKey ?
                          <div
                            className={classNames("checkbox__background-image", disableSelected && 'checkbox__background-image--disabled')}
                            style={{
                              backgroundImage: `url(${selectedEx[imageKey]})`
                            }}
                          />
                          :
                          icon
                        }
                      </div>
                    </div>
                  </div>
                  <div className={`data-table__option_body`}>
                    <div className={classNames("create_card-option-title", { "create_card-option-title--large": isLarge })}>
                      {selectedTitle || selectedOption}
                    </div>
                    <div className="create_card-option-subtitle">
                      {(selectedEx && selectedEx.baseModel && selectedEx.baseModel.name)}
                    </div>
                  </div>
                  <div className={`data-table__option_cevron`} onClick={() => this.onEdit(this.state.showExpand)}>
                    {showExpand ? <UpCevron /> : <DownCevron />}
                  </div>
                </div>
                <div className={classNames(`create_card-options`, {
                  'create_card-options_visible create_card-options_visible_fullwidth': this.state.showExpand,
                  'create_card-options_visible--light': isLight && this.state.showExpand
                })}>
                  <Scrollbars
                    autoHeight
                    autoHide={autoHide}
                    autoHideDuration={1}
                    autoHeightMax={220}
                    autoHeightMin={this.state.showExpand ? 100 : 0}
                    renderView={props => <div {...props}
                      className={classNames(``, {
                      })} />
                    }
                  >
                    <div>
                      {filteredData().map(item =>
                        <div className="create_card-option" onClick={() => this.onSelect(item.name, item._id)} key={`${item._id}_${item.name}`}>
                          <div className={classNames("create_card__icon", imageKey && 'create_card__icon--image')}>
                            <div className={`checkbox`}>
                              <div className={classNames("checkbox__image checkbox__image_lg checkbox__empty", imageKey && 'checkbox__image--image')}>
                                {imageKey ?
                                  <div
                                    className="checkbox__background-image"
                                    style={{
                                      backgroundImage: `url(${item[imageKey]})`
                                    }}
                                  />
                                  :
                                  icon
                                }
                              </div>
                            </div>
                          </div>
                          <div className={`data-table__option_body`}>
                            <div className="create_card-option-title">
                              {item.name}
                            </div>
                            <div className="create_card-option-subtitle">
                              {item.baseModel && item.baseModel.name}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </Scrollbars>
                </div>
              </div>

            </div>
          </div>
        </div>
      </OutsideClickHandler>
    );
  }
}

SelectItemCard.propTypes = {
  scopes: PropTypes.array,
  history: PropTypes.object,
  scopeDetails: PropTypes.object,
  listScopeRequest: PropTypes.func,
};

export default compose(withRouter)(SelectItemCard);
